<template>
  <div>
    <b-row class="mb-3">
      <b-col cols="12" class="mb-3">
        <h3>ข้อมูลพนักงานขับ</h3>
      </b-col>
      <b-col cols="12">
        <ValidationProvider rules="required" v-slot="{ errors }" tag="div">
          <b-form-group label="พนักงานขับรถ" label-for="input-driver">
            <multiselect
              v-model="form.driver"
              id="input-driver"
              deselect-label="Can't remove this value"
              track-by="id"
              label="fullName"
              placeholder="เลือกพนักงานขับ"
              :options="empoyeeList"
              :allow-empty="false"
              :class="{
                'custom-select-error': errors[0],
              }">
            </multiselect>
            <!-- :disabled="!!form.driver" -->
            <p class="custom-meassage-error" v-if="errors[0]">
              {{ errors[0] }}
            </p>
          </b-form-group>
        </ValidationProvider>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col cols="12" class="mb-3">
        <h3>วันเวลาเริ่ม จบงาน</h3>
      </b-col>
      <b-col cols="6">
        <ValidationProvider rules="required" v-slot="{ errors }">
          <b-form-group label="เริ่มงาน" label-for="input-start-job">
            <b-form-input
              id="input-start-job"
              type="datetime-local"
              @change="onStartDateChange"
              v-model="form.driverDateStart"
              :state="!errors.length ? null : false">
            </b-form-input>
            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
      <b-col cols="6">
        <ValidationProvider rules="required" v-slot="{ errors }">
          <b-form-group label="จบงาน" label-for="input-end-job">
            <b-form-input
              id="input-end-job"
              type="datetime-local"
              v-model="form.driverDateEnd"
              :min="minEndDate"
              :state="!errors.length ? null : false">
            </b-form-input>
            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import empoyeeServices from "@/api/empoyee.service.js";
import { ValidationProvider } from "vee-validate";

export default {
  props: {
    form: {
      type: Object,
    },
  },
  data() {
    return {
      empoyeeList: [],
      minEndDate: null,
    };
  },
  components: {
    ValidationProvider,
  },
  async created() {
    await this.getEmpoyee();
  },
  methods: {
    async getEmpoyee() {
      try {
        const response = await empoyeeServices.getEmpoyee();
        this.empoyeeList = response.data.data.map((item) => {
          return {
            ...item,
            fullName: `${item.firstname} ${item.lastname}`,
          };
        });
      } catch (error) {}
    },
    onStartDateChange() {
      // กำหนดค่า min ของวันที่จบงานให้มากกว่าหรือเท่ากับวันที่เริ่มงาน
      this.minEndDate = this.form.driverDateStart;

      // ถ้าเลือกวันที่เริ่มงานใหม่และวันที่จบงานก่อนวันที่เริ่มงาน ก็เคลียร์ค่า
      if (
        this.form.driverDateEnd &&
        this.form.driverDateEnd < this.form.driverDateStart
      ) {
        this.form.driverDateEnd = null;
      }
    },
  },
};
</script>
